import React, { Component } from "react"
import { connect } from "react-redux"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

import { autocompleteTopicsRequest } from "../../actions/autocomplete-actions"
import { topicItemSaveRequest } from "../../actions/topic-actions"

import SelectTags from "./tags/SelectTags"

class AddConceptMappingModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedInsightAreas: []
        }

        this.onValueChange = this.onValueChange.bind(this)
        this.onClickSave = this.onClickSave.bind(this)
    }

    onValueChange(insightAreas) {
        this.setState({
            selectedInsightAreas: insightAreas
        })
    }

    onClickSave() {
        this.state.selectedInsightAreas
            .map(({ id }) => ({
                id,
                mappings_add: [{ positive: [this.props.concept.id] }]
            }))
            .forEach(item => this.props.onSave(item.id, item))

        this.props.toggle()
    }

    render() {
        const { isOpen, toggle, onTopicsSearch } = this.props

        return (
            <Modal
                isOpen={isOpen}
                toggle={toggle}
                className="modal-dialog-v-centered modal-horizontally-centered"
            >
                <ModalHeader>Add Mapping</ModalHeader>
                <ModalBody>
                    <p>Assign this concept to</p>
                    <SelectTags
                        name="topics"
                        value={this.state.selectedInsightAreas}
                        loadOptions={onTopicsSearch}
                        onChange={this.onValueChange}
                    />
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-cancel col" onClick={toggle}>
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary col"
                        onClick={this.onClickSave}
                    >
                        Save
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    onSave: (id, item) => dispatch(topicItemSaveRequest(id, item)),
    onTopicsSearch: (searchTerm, callback) => {
        dispatch(autocompleteTopicsRequest(searchTerm, callback))
    }
})

export default connect(null, mapDispatchToProps)(AddConceptMappingModal)
